import { call, put, select, takeEvery } from "redux-saga/effects";
import { push } from "connected-react-router";
import {
    onDishLoad,
    onDishLoadSuccess,
    onDishLoadFail,
    onDishUpdate,
    onDishUpdateSuccess,
    onDishUpdateFail,
    onDishNewLoad,
    onDishNewSave,
    onDishNewLoadSuccess,
    onDishNewLoadFail,
    onDishNewSaveSuccess,
    onDishNewSaveFail,
    onAllergensLoad,
    onAllergensLoadSuccess,
    onAllergensLoadFail,
    onAllergensUpdate,
    onAllergenshUpdateSuccess,
    onAllergensUpdateFail,
    onModifierUpdateFail,
    onModifierUpdateSuccess,
    onModifierUpdate,
} from "./actions";
import {
    dishLoad,
    dishNewLoad,
    dishUpdate,
    dishSave,
    allergensLoad,
    allergensUpdate,
    modifierUpdate,
} from "./api";

function* fetchInitData(action) {
    try {
        const response = yield call(dishLoad, action.itemId);
        yield put(onDishLoadSuccess(response));
    } catch (e) {
        yield put(onDishLoadFail(e));
    }
}

function* updateDish(action) {
    try {
        const dish = yield select(({ dish }) => dish.dish);
        const restaurants = yield select(({ dish }) => dish.restaurants);

        const response = yield call(
            dishUpdate,
            dish,
            restaurants,
            action.photo,
            action.selectedIds,
            action.isCheckAllFutureLocations,
            action.isCheckAll,
        );
        yield put(onDishUpdateSuccess(response));
        yield put(push("/chain/categories"));
    } catch (e) {
        yield put(onDishUpdateFail(e));
    }
}

function* updateModifier(action) {
    try {
        const dish = yield select(({ dish }) => dish.dish);
        const restaurants = yield select(({ dish }) => dish.restaurants);

        const response = yield call(
            modifierUpdate,
            dish,
            action.photo,
            restaurants,
            action.archived );
        yield put(onModifierUpdateSuccess(response));
    } catch (e) {
        yield put(onModifierUpdateFail(e));
    }
}

function* updateAllergens(action) {
    try {
        const dish = yield select(({ dish }) => dish.dish);
        const allergens = yield select(({ dish }) => dish.allergens);

        const response = yield call(allergensUpdate, dish, allergens);
        yield put(onAllergenshUpdateSuccess(response));
        yield put(push("/chain/categories"));
    } catch (e) {
        yield put(onAllergensUpdateFail(e));
    }
}

function* newSave(action) {
    try {
        const dish = yield select((state) => state.dish.dish);
        const restaurants = yield select(({ dish }) => dish.restaurants);

        const response = yield call(
            dishSave, 
            dish, 
            restaurants)
            action.photo,
            action.selectedIds,
            action.isCheckAllFutureLocations,
            action.isCheckAll,
        yield put(onDishNewSaveSuccess(response));
        yield put(push("/chain/categories"));
    } catch (e) {
        yield put(onDishNewSaveFail(e));
    }
}

function* newLoad() {
    try {
        const response = yield call(dishNewLoad);
        yield put(onDishNewLoadSuccess(response));
    } catch (e) {
        yield put(onDishNewLoadFail(e));
    }
}

function* allergensLoadData() {
    try {
        const response = yield call(allergensLoad);

        yield put(onAllergensLoadSuccess(response));
    } catch (e) {
        yield put(onAllergensLoadFail(e));
    }
}

function* categoriesSaga() {
    yield takeEvery(onDishLoad().type, fetchInitData);
    yield takeEvery(onDishUpdate().type, updateDish);
    yield takeEvery(onModifierUpdate().type, updateModifier);
    yield takeEvery(onDishNewLoad().type, newLoad);
    yield takeEvery(onAllergensUpdate().type, updateAllergens);
    yield takeEvery(onAllergensLoad().type, allergensLoadData);
    yield takeEvery(onDishNewSave().type, newSave);
}

export default categoriesSaga;
